import config, { isLocal } from '@/config';
import { isStaleChunkError } from '@/util/staleChunkError';
import { datadogLogs } from '@datadog/browser-logs';

const FILTERED_LOG_PATTERNS = [
    'Detected a large number of updates inside startTransition',
    // Benign: the browser Reporting API surfaces an aborted long-poll fetch whenever a
    // Firestore onSnapshot listener unsubscribes mid-request (route change, unmount) and
    // recycles its Listen or Write channel. Not an application error. Both methods are listed
    // per channel because WebChannel runs each one as a long-lived GET backchannel plus POSTs;
    // the GET is what aborts in practice, but an in-flight POST tears down the same way.
    'Fetch error GET https://firestore.googleapis.com/google.firestore.v1.Firestore/Listen',
    'Fetch error POST https://firestore.googleapis.com/google.firestore.v1.Firestore/Listen',
    'Fetch error GET https://firestore.googleapis.com/google.firestore.v1.Firestore/Write',
    'Fetch error POST https://firestore.googleapis.com/google.firestore.v1.Firestore/Write',
    // Benign: Firebase Auth's proactive hourly ID-token refresh fails with `Failed to fetch`
    // (status 0) whenever an idle admin tab is offline — laptop asleep, wifi switching. The
    // token manager retries on the next getIdToken(), so a dropped refresh is never user-visible.
    'Fetch error POST https://securetoken.googleapis.com/v1/token',
];

datadogLogs.init({
    clientToken: config.datadog.clientToken,
    site: 'us5.datadoghq.com',
    service: 'rock-admin',
    env: config.app.env,
    version: config.app.version,
    forwardConsoleLogs: 'all',
    forwardReports: 'all',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    beforeSend: (logEvent) => {
        const message = logEvent.message ?? '';
        // `staleChunkReload` owns this failure: it reloads, or logs a genuinely missing chunk separately.
        if (isStaleChunkError(message)) return false;
        return !FILTERED_LOG_PATTERNS.some((pattern) => message.includes(pattern));
    },
    useSecureSessionCookie: !isLocal(),
});

// Local logs to the console only; every deployed env (dev/staging/prod) ships to Datadog too —
// client-side errors were invisible while this was prod-only (c50708af). The bill concern that
// motivated that gate was RUM sessions, not browser logs.
datadogLogs.logger.setHandler(isLocal() ? ['console'] : ['http', 'console']);

export { datadogLogs };
